module.exports = __webpack_public_path__ + "img/saintvincentandthegrenadines.7b843b18.svg";